var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiveLongFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 200 30 L 180 30 L 150 40 L 30 40 L 30 160 L 150 160 L 180 170 L 200 170",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 95 115 L 99.5 115 L 99.5 85 L 37.5 85 L 37.5 115 L 67.5 115 L 67.5 85",
    fill: "transparent",
    stroke: "black",
    strokeWidth: 6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 65,
    x2: 45,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 65,
    x2: 60,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 65,
    x2: 75,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 65,
    x2: 90,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 65,
    x2: 105,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 65,
    x2: 120,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 65,
    x2: 135,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 65,
    x2: 150,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 65,
    x2: 165,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 65,
    x2: 180,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 65,
    x2: 195,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 135,
    x2: 45,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 135,
    x2: 60,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 135,
    x2: 75,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 135,
    x2: 90,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 135,
    x2: 105,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 135,
    x2: 120,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 135,
    x2: 135,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 135,
    x2: 150,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 135,
    x2: 165,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 135,
    x2: 180,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 135,
    x2: 195,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 195,
    y1: 100,
    x2: 185,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 100,
    x2: 170,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 165,
    y1: 100,
    x2: 155,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 100,
    x2: 140,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 135,
    y1: 100,
    x2: 125,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 100,
    x2: 110,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 90 40 C 90 25, 110 25, 110 40",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 115 40 C 115 25, 135 25, 135 40",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 90 160 C 90 175, 110 175, 110 160",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 115 160 C 115 175, 135 175, 135 160",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 40 40 L 40 35 C 40 29, 50 29, 50 35 L 50 40",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 55 40 L 55 35 C 55 29, 65 29, 65 35 L 65 40",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 40 160 L 40 165 C 40 171, 50 171, 50 165 L 50 160",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 55 160 L 55 165 C 55 171, 65 171, 65 165 L 65 160",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), "\n  Sorry, your browser does not support inline SVG.\n");
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiveLongFront);
export default __webpack_public_path__ + "static/media/FiveLongFront.921675476a364caaff3ea1e5e93e718f.svg";
export { ForwardRef as ReactComponent };